// // import React, { useState, useEffect } from 'react';
// // import { useLocation } from 'react-router-dom';
// // import { getAllCampaigns } from '../components/api2';
// // import AllCamp from '../pages/allCampaign';

// // const ITEMS_PER_PAGE = 10;
// // const PAGES_DISPLAYED = 5;

// // const Live = () => {
// //     const location = useLocation();
// //     const [campaigns, setCampaigns] = useState([]);
// //     const [currentPage, setCurrentPage] = useState(1);

// //     useEffect(() => {
// //         const fetchCampaigns = async () => {
// //             try {
// //                 const allCampaigns = await getAllCampaigns();
// //                 console.log('API response:', allCampaigns); // Debugging log to check API response

// //                 // Remove filtering by 'approve' field
// //                 setCampaigns(allCampaigns);
// //             } catch (error) {
// //                 console.error('Error fetching campaigns:', error);
// //             }
// //         };

// //         fetchCampaigns();
// //     }, [location]); // Add location dependency if route change affects fetching

// //     const totalPages = Math.ceil(campaigns.length / ITEMS_PER_PAGE);
// //     const startPage = Math.max(1, Math.min(currentPage - Math.floor(PAGES_DISPLAYED / 2), totalPages - PAGES_DISPLAYED + 1));
// //     const endPage = Math.min(totalPages, startPage + PAGES_DISPLAYED - 1);
// //     const paginatedCampaigns = campaigns.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);

// //     const handlePageChange = (page) => {
// //         setCurrentPage(page);
// //     };

// //     return (
// //         <div className='container'>
// //             <h1 className='title is-1 has-text-centered'><b>Brand Collabs For You</b></h1>
// //             <h2 className='subtitle is-3 has-text-centered'>BROUGHT TO YOU WITH LOVE FROM HOBO.VIDEO</h2>
// //             <div className="columns is-multiline is-centered">
// //                 {paginatedCampaigns.length > 0 ? (
// //                     paginatedCampaigns.map((campaign, index) => (
// //                         <div
// //                             key={campaign._id || index}
// //                             className={`column ${paginatedCampaigns.length === 1 ? 'is-full' : 'is-half'}`}
// //                         >
// //                             <AllCamp campaign={campaign} alignLeft={index % 2 === 0} />
// //                         </div>
// //                     ))
// //                 ) : (
// //                     <div className="has-text-centered">No campaigns to display</div>
// //                 )}

// //             </div>
// //             <div className="pagination is-centered" role="navigation" aria-label="pagination">
// //                 {currentPage > 1 && (
// //                     <button className="pagination-previous" onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
// //                 )}
// //                 {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i).map((page) => (
// //                     <button key={page} className={`pagination-link ${page === currentPage ? 'is-current' : ''}`} aria-label={`Goto page ${page}`} onClick={() => handlePageChange(page)}>
// //                         {page}
// //                     </button>
// //                 ))}
// //                 {currentPage < totalPages && (
// //                     <button className="pagination-next" onClick={() => handlePageChange(currentPage + 1)}>Next</button>
// //                 )}
// //             </div>
// //         </div>
// //     );
// // };

// // export default Live;
// // import React, { useState, useEffect } from 'react';
// // import { useLocation } from 'react-router-dom';
// // import { getAllCampaigns } from '../components/api2';
// // import AllCamp from '../pages/allCampaign';

// // const ITEMS_PER_PAGE = 10;
// // const PAGES_DISPLAYED = 5;

// // const Live = () => {
// //     const location = useLocation();
// //     const [campaigns, setCampaigns] = useState([]);
// //     const [loading, setLoading] = useState(false);
// //     const [currentPage, setCurrentPage] = useState(() => {
// //         const savedPage = localStorage.getItem('campaignPage');
// //         return savedPage ? parseInt(savedPage, 10) : 1;
// //     });

// //     useEffect(() => {
// //         const fetchCampaigns = async () => {
// //             setLoading(true);
// //             try {
// //                 const allCampaigns = await getAllCampaigns();

// //                 // Sort by createdAt descending (newest first)
// //                 allCampaigns.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

// //                 setCampaigns(allCampaigns);
// //             } catch (error) {
// //                 console.error('Error fetching campaigns:', error);
// //             } finally {
// //                 setLoading(false);
// //             }
// //         };

// //         fetchCampaigns();
// //     }, [location]);


// //     useEffect(() => {
// //         localStorage.setItem('campaignPage', currentPage.toString());
// //     }, [currentPage]);

// //     const totalPages = Math.ceil(campaigns.length / ITEMS_PER_PAGE);
// //     const startPage = Math.max(1, Math.min(currentPage - Math.floor(PAGES_DISPLAYED / 2), totalPages - PAGES_DISPLAYED + 1));
// //     const endPage = Math.min(totalPages, startPage + PAGES_DISPLAYED - 1);
// //     const paginatedCampaigns = campaigns.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);

// //     const handlePageChange = (page) => {
// //         setCurrentPage(page);
// //     };

// //     return (
// //         <div className="container">
// //             <h1 className="title is-1 has-text-centered"><b>Brand Collabs For You</b></h1>
// //             <h2 className="subtitle is-3 has-text-centered">BROUGHT TO YOU WITH LOVE FROM HOBO.VIDEO</h2>

// //             {loading ? (
// //                 <div className="has-text-centered" style={{ margin: '100px 0' }}>
// //                     <span className="loader"></span>
// //                     <p>Loading campaigns...</p>
// //                 </div>
// //             ) : (
// //                 <>
// //                     <div className="columns is-multiline is-centered">
// //                         {paginatedCampaigns.length > 0 ? (
// //                             paginatedCampaigns.map((campaign, index) => (
// //                                 <div
// //                                     key={campaign._id || index}
// //                                     className={`column ${paginatedCampaigns.length === 1 ? 'is-full' : 'is-half'}`}
// //                                 >
// //                                     <AllCamp campaign={campaign} alignLeft={index % 2 === 0} />
// //                                 </div>
// //                             ))
// //                         ) : (
// //                             <div className="has-text-centered">No campaigns to display</div>
// //                         )}
// //                     </div>

// //                     <div className="pagination is-centered" role="navigation" aria-label="pagination">
// //                         {currentPage > 1 && (
// //                             <button className="pagination-previous" onClick={() => handlePageChange(currentPage - 1)}>
// //                                 Previous
// //                             </button>
// //                         )}
// //                         {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i).map((page) => (
// //                             <button
// //                                 key={page}
// //                                 className={`pagination-link ${page === currentPage ? 'is-current' : ''}`}
// //                                 aria-label={`Goto page ${page}`}
// //                                 onClick={() => handlePageChange(page)}
// //                             >
// //                                 {page}
// //                             </button>
// //                         ))}
// //                         {currentPage < totalPages && (
// //                             <button className="pagination-next" onClick={() => handlePageChange(currentPage + 1)}>
// //                                 Next
// //                             </button>
// //                         )}
// //                     </div>
// //                 </>
// //             )}
// //         </div>
// //     );
// // };

// // export default Live;
// import React, { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';
// import { getAllCampaigns } from '../components/api2';
// import AllCamp from '../pages/allCampaign';

// const ITEMS_PER_PAGE = 10;
// const PAGES_DISPLAYED = 5;

// const Live = () => {
//     const location = useLocation();
//     const [campaigns, setCampaigns] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [currentPage, setCurrentPage] = useState(() => {
//         const savedPage = localStorage.getItem('campaignPage');
//         return savedPage ? parseInt(savedPage, 10) : 1;
//     });

//     useEffect(() => {
//         const fetchCampaigns = async () => {
//             setLoading(true);
//             try {
//                 const allCampaigns = await getAllCampaigns();

//                 // Sort by createdAt descending (newest first)
//                 allCampaigns.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

//                 setCampaigns(allCampaigns);
//             } catch (error) {
//                 console.error('Error fetching campaigns:', error);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchCampaigns();
//     }, [location]);


//     useEffect(() => {
//         localStorage.setItem('campaignPage', currentPage.toString());
//     }, [currentPage]);

//     const totalPages = Math.ceil(campaigns.length / ITEMS_PER_PAGE);
//     const startPage = Math.max(1, Math.min(currentPage - Math.floor(PAGES_DISPLAYED / 2), totalPages - PAGES_DISPLAYED + 1));
//     const endPage = Math.min(totalPages, startPage + PAGES_DISPLAYED - 1);
//     const paginatedCampaigns = campaigns.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);

//     const handlePageChange = (page) => {
//         setCurrentPage(page);
//     };

//     return (
//         <div className="container">
//             <h1 className="title is-1 has-text-centered"><b>Brand Collabs For You</b></h1>
//             <h2 className="subtitle is-3 has-text-centered">BROUGHT TO YOU WITH LOVE FROM HOBO.VIDEO</h2>

//             {loading ? (
//                 <div className="has-text-centered" style={{ margin: '100px 0' }}>
//                     <span className="loader"></span>
//                     <p>Loading campaigns...</p>
//                 </div>
//             ) : (
//                 <>
//                     <div className="columns is-multiline is-centered">
//                         {paginatedCampaigns.length > 0 ? (
//                             paginatedCampaigns.map((campaign, index) => (
//                                 <div
//                                     key={campaign._id || index}
//                                     className={`column ${paginatedCampaigns.length === 1 ? 'is-full' : 'is-half'}`}
//                                 >
//                                     <AllCamp campaign={campaign} alignLeft={index % 2 === 0} />
//                                 </div>
//                             ))
//                         ) : (
//                             <div className="has-text-centered">No campaigns to display</div>
//                         )}
//                     </div>

//                     <div className="pagination is-centered" role="navigation" aria-label="pagination">
//                         {currentPage > 1 && (
//                             <button className="pagination-previous" onClick={() => handlePageChange(currentPage - 1)}>
//                                 Previous
//                             </button>
//                         )}
//                         {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i).map((page) => (
//                             <button
//                                 key={page}
//                                 className={`pagination-link ${page === currentPage ? 'is-current' : ''}`}
//                                 aria-label={`Goto page ${page}`}
//                                 onClick={() => handlePageChange(page)}
//                             >
//                                 {page}
//                             </button>
//                         ))}
//                         {currentPage < totalPages && (
//                             <button className="pagination-next" onClick={() => handlePageChange(currentPage + 1)}>
//                                 Next
//                             </button>
//                         )}
//                     </div>
//                 </>
//             )}
//         </div>
//     );
// };

// export default Live;
// import React, { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';
// import { getAllCampaigns } from '../components/api2';
// import AllCamp from '../pages/allCampaign';

// const ITEMS_PER_PAGE = 10;
// const PAGES_DISPLAYED = 5;

// const Live = () => {
//     const location = useLocation();
//     const [campaigns, setCampaigns] = useState([]);
//     const [currentPage, setCurrentPage] = useState(1);

//     useEffect(() => {
//         const fetchCampaigns = async () => {
//             try {
//                 const allCampaigns = await getAllCampaigns();
//                 console.log('API response:', allCampaigns); // Debugging log to check API response

//                 // Remove filtering by 'approve' field
//                 setCampaigns(allCampaigns);
//             } catch (error) {
//                 console.error('Error fetching campaigns:', error);
//             }
//         };

//         fetchCampaigns();
//     }, [location]); // Add location dependency if route change affects fetching

//     const totalPages = Math.ceil(campaigns.length / ITEMS_PER_PAGE);
//     const startPage = Math.max(1, Math.min(currentPage - Math.floor(PAGES_DISPLAYED / 2), totalPages - PAGES_DISPLAYED + 1));
//     const endPage = Math.min(totalPages, startPage + PAGES_DISPLAYED - 1);
//     const paginatedCampaigns = campaigns.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);

//     const handlePageChange = (page) => {
//         setCurrentPage(page);
//     };

//     return (
//         <div className='container'>
//             <h1 className='title is-1 has-text-centered'><b>Brand Collabs For You</b></h1>
//             <h2 className='subtitle is-3 has-text-centered'>BROUGHT TO YOU WITH LOVE FROM HOBO.VIDEO</h2>
//             <div className="columns is-multiline is-centered">
//                 {paginatedCampaigns.length > 0 ? (
//                     paginatedCampaigns.map((campaign, index) => (
//                         <div
//                             key={campaign._id || index}
//                             className={`column ${paginatedCampaigns.length === 1 ? 'is-full' : 'is-half'}`}
//                         >
//                             <AllCamp campaign={campaign} alignLeft={index % 2 === 0} />
//                         </div>
//                     ))
//                 ) : (
//                     <div className="has-text-centered">No campaigns to display</div>
//                 )}

//             </div>
//             <div className="pagination is-centered" role="navigation" aria-label="pagination">
//                 {currentPage > 1 && (
//                     <button className="pagination-previous" onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
//                 )}
//                 {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i).map((page) => (
//                     <button key={page} className={`pagination-link ${page === currentPage ? 'is-current' : ''}`} aria-label={`Goto page ${page}`} onClick={() => handlePageChange(page)}>
//                         {page}
//                     </button>
//                 ))}
//                 {currentPage < totalPages && (
//                     <button className="pagination-next" onClick={() => handlePageChange(currentPage + 1)}>Next</button>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default Live;





import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getAllCampaigns } from '../components/api2';
import AllCamp from '../pages/allCampaign';

const ITEMS_PER_PAGE = 10;
const PAGES_DISPLAYED = 5;

const Live = () => {
    const location = useLocation();
    const [campaigns, setCampaigns] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(() => {
        const savedPage = localStorage.getItem('campaignPage');
        return savedPage ? parseInt(savedPage, 10) : 1;
    });

    // useEffect(() => {
    //     const fetchCampaigns = async () => {
    //         setLoading(true);
    //         try {
    //             const allCampaigns = await getAllCampaigns();

    //             // Sort by createdAt descending (newest first)
    //             allCampaigns.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    //             setCampaigns(allCampaigns);
    //         } catch (error) {
    //             console.error('Error fetching campaigns:', error);
    //         } finally {
    //             setLoading(false);
    //         }
    //     };

    //     fetchCampaigns();
    // }, [location]);

    // useEffect(() => {
    //     const fetchCampaigns = async (skipCache = false) => {
    //         try {
    //             let cached = null;

    //             // ✅ Load instantly from cache (no loader)
    //             if (!skipCache) {
    //                 cached = localStorage.getItem("campaigns");
    //                 if (cached) {
    //                     setCampaigns(JSON.parse(cached));
    //                 }
    //             }

    //             // ✅ Show loader only if nothing in cache
    //             if (!cached) {
    //                 setLoading(true);
    //             }

    //             // 🔄 Fetch fresh campaigns in background
    //             const allCampaigns = await getAllCampaigns();
    //             allCampaigns.sort(
    //                 (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    //             );

    //             const cachedData = cached ? JSON.parse(cached) : null;

    //             // ✅ Update only if changed
    //             if (
    //                 !cachedData ||
    //                 JSON.stringify(allCampaigns) !== JSON.stringify(cachedData)
    //             ) {
    //                 setCampaigns(allCampaigns);
    //                 localStorage.setItem("campaigns", JSON.stringify(allCampaigns));
    //             }
    //         } catch (error) {
    //             console.error("Error fetching campaigns:", error);
    //         } finally {
    //             setLoading(false);
    //         }
    //     };

    //     fetchCampaigns();

    //     // 🔁 Refresh every 1 min in background (no loader)
    //     const interval = setInterval(() => {
    //         fetchCampaigns(true);
    //     }, 60000);

    //     return () => clearInterval(interval);
    // }, []);

    useEffect(() => {
        const fetchCampaigns = async (skipCache = false) => {
            try {
                let cached = null;

                // ✅ Load instantly from cache
                if (!skipCache) {
                    cached = localStorage.getItem("campaigns");
                    if (cached) {
                        setCampaigns(JSON.parse(cached));
                    }
                }

                // ✅ Show loader only if nothing in cache AND it's not auto refresh
                if (!cached && !skipCache) {
                    setLoading(true);
                }

                // 🔄 Fetch fresh campaigns in background
                const allCampaigns = await getAllCampaigns();
                allCampaigns.sort(
                    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
                );

                const cachedData = cached ? JSON.parse(cached) : null;

                // ✅ Update only if changed
                if (
                    !cachedData ||
                    JSON.stringify(allCampaigns) !== JSON.stringify(cachedData)
                ) {
                    setCampaigns(allCampaigns);
                    localStorage.setItem("campaigns", JSON.stringify(allCampaigns));
                }
            } catch (error) {
                console.error("Error fetching campaigns:", error);
            } finally {
                // ✅ Hide loader only if it was shown
                if (!skipCache) {
                    setLoading(false);
                }
            }
        };

        fetchCampaigns();

        // 🔁 Refresh every 1 min in background (no loader)
        const interval = setInterval(() => {
            fetchCampaigns(true); // auto refresh without loader
        }, 60000);

        return () => clearInterval(interval);
    }, []);



    const totalPages = Math.ceil(campaigns.length / ITEMS_PER_PAGE);
    const startPage = Math.max(1, Math.min(currentPage - Math.floor(PAGES_DISPLAYED / 2), totalPages - PAGES_DISPLAYED + 1));
    const endPage = Math.min(totalPages, startPage + PAGES_DISPLAYED - 1);
    const paginatedCampaigns = campaigns.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    return (
        <div className="container">
            <h1 className="title is-1 has-text-centered"><b>Brand Collabs For You</b></h1>
            <h2 className="subtitle is-3 has-text-centered">BROUGHT TO YOU WITH LOVE FROM HOBO.VIDEO</h2>

            {loading ? (
                <div className="has-text-centered" style={{ margin: '100px 0' }}>
                    <span className="loader"></span>
                    <p>Loading campaigns...</p>
                </div>
            ) : (
                <>
                    <div className="columns is-multiline is-centered">
                        {paginatedCampaigns.length > 0 ? (
                            paginatedCampaigns.map((campaign, index) => (
                                <div
                                    key={campaign._id || index}
                                    className={`column ${paginatedCampaigns.length === 1 ? 'is-full' : 'is-half'}`}
                                >
                                    <AllCamp campaign={campaign} alignLeft={index % 2 === 0} />
                                </div>
                            ))
                        ) : (
                            <div className="has-text-centered">No campaigns to display</div>
                        )}
                    </div>

                    <div className="pagination is-centered" role="navigation" aria-label="pagination">
                        {currentPage > 1 && (
                            <button className="pagination-previous" onClick={() => handlePageChange(currentPage - 1)}>
                                Previous
                            </button>
                        )}
                        {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i).map((page) => (
                            <button
                                key={page}
                                className={`pagination-link ${page === currentPage ? 'is-current' : ''}`}
                                aria-label={`Goto page ${page}`}
                                onClick={() => handlePageChange(page)}
                            >
                                {page}
                            </button>
                        ))}
                        {currentPage < totalPages && (
                            <button className="pagination-next" onClick={() => handlePageChange(currentPage + 1)}>
                                Next
                            </button>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

export default Live;